import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "src/store/store";
import {setCurrentLicenseKey, setStepIncrease} from "src/store/features/licenseSlice";
import Toast from "../../ui/Toast";
import TourButton from "../../TourButton/TourButton";
import Joyride, {STATUS} from "react-joyride"
import {DocumentationLink} from "../../ui/DocumentationLink";

const LicenseCode = () => {
    const [licenseKey, setLicenseKey] = useState("")
    const [toast, setToast] = useState({isSuccess: false, message: "", showToast: false});
    const apiUrl = `https://customer-service.oska.com.tr/api/v1/license/hakedis/offline?license_key=${licenseKey}`
    const dispatch = useAppDispatch()
    const stepIncrease = useAppSelector((state) => state.license.stepIncrease)
    const [state, setState] = useState({
        run: false
    });
    const locale = {
        back: 'Geri',
        close: 'Kapat',
        last: 'Son',
        next: 'İleri',
        skip: "Atla"
    }
    const startTour = () => {
        setState({run: true})
    }
    const handleChange = (e: any) => {
        const newInputKey = e.target.value;
        setLicenseKey(newInputKey);
    };
    const handleJoyrideCallback = (data: any) => {
        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        if (finishedStatuses.includes(status)) {
            setState({run: false})
        }
    };
    const onLicenseCode = () => {
        fetch(apiUrl).then(response => response.json())
            .then(data => {
                if (data.status) {
                    dispatch(setCurrentLicenseKey(licenseKey))
                    setToast({message: data.message, showToast: true, isSuccess: true})
                    setTimeout(() => {
                        setToast({...toast, showToast: false})
                    }, 3000)
                    const url = new Blob([data.data], {type: 'text/plain'})
                    const a = document.createElement('a')
                    a.href = URL.createObjectURL(url)
                    a.setAttribute('download', 'offline_activation.act'); //set download attribute to link
                    document.body.appendChild(a);
                    a.click();
                    dispatch(setStepIncrease(stepIncrease + 1))
                } else {
                    setToast({message: data.message, showToast: true, isSuccess: false})
                    setTimeout(() => {
                        setToast({...toast, showToast: false})
                    }, 3000)
                }
            })
    }

    return (
        <div>
            {state.run ?
                <Joyride continuous callback={handleJoyrideCallback} run={state.run} steps={[
                    {
                        content: <h2>Lisans kodu gönderme rehberi için devam ediniz.</h2>,
                        placement: "center",
                        target: "body"
                    },
                    {
                        content: <h2>Buradaki boş yere HakedişPlus lisansınızı eksiksiz bir şekilde yapıştırın.</h2>,
                        placement: "bottom",
                        target: "input"
                    },
                    {
                        content: <h2>Buradaki butona basarak lisansınız gönderip devam edebilirsiniz.</h2>,
                        placement: "bottom",
                        target: "#sendButton"
                    },
                ]} hideCloseButton
                         locale={locale}
                         scrollToFirstStep showSkipButton showProgress/> : ''}

            <section className="py-14 max-w-screen-xl mx-auto">
                <div
                    className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-900 dark:border-gray-800 dark:shadow-gray-300 transition-colors duration-300">
                    <div className="relative z-10 max-w-xl mx-auto sm:text-center">
                        <div className="space-y-3">
                            <h3 className="text-3xl font-bold">
                                Lisans Kodu
                            </h3>
                            <p className=" leading-relaxed">
                                Oska Yazılım tarafından size iletilen ürün lisansını aşağıdaki kutucuğa girin.
                            </p>
                        </div>
                        <div className="mt-6  items-center justify-center rounded-lg p-1">
                            <form
                                onSubmit={(e) => e.preventDefault()}
                                className="items-center justify-center sm:flex">
                                <input
                                    type="text"
                                    id="keyInput"
                                    maxLength={22}
                                    value={licenseKey}
                                    onChange={handleChange}
                                    placeholder="P0001-AAAAAA-BBBB-CCCC"
                                    className="text-gray-500 w-full p-3 rounded-md border outline-none focus:border-indigo-600"
                                />
                                <button
                                    id="sendButton"
                                    onClick={onLicenseCode}
                                    className="w-full mt-3 px-5 py-3 rounded-md text-white bg-blue-600 hover:bg-blue-800 active:bg-indigo-700 duration-150 outline-none shadow-md focus:shadow-none focus:ring-2 ring-offset-2 ring-indigo-600 sm:mt-0 sm:ml-3 sm:w-auto"
                                >
                                    Gönder
                                </button>
                            </form>

                        </div>
                        <DocumentationLink/>
                    </div>
                    <Toast message={toast.message} showToast={toast.showToast} isSuccess={toast.isSuccess}/>
                </div>
            </section>
            <TourButton onClick={startTour}/>
        </div>
    )
}

export default LicenseCode

